<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. A Tale of Two Bridges</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. On Top of Old Hogback</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. A Story of True Friendship</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. A Mountain Boy’s Life Story</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Big Alec</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. The Murder of a Revenuer</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Thunder in the Mountains</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. A Jail Break to Remember</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. A Tender Farewell</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. The Boy from Horse Creek</span></p>
<p class="toc"><span href="#/Chapter11#C11" title="Link target outside of Sample">11. Grinding Corn in the Dark Corner</span></p>
<p class="toc"><span href="#/Chapter12#C12" title="Link target outside of Sample">12. The Hensley Burning</span></p>
<p class="toc"><span href="#/Chapter13#C13" title="Link target outside of Sample">13. A Light in the Dark Corner</span></p>
<p class="toc"><span href="#/Chapter14#C14" title="Link target outside of Sample">14. Trouble in a Jug</span></p>
<p class="toc"><span href="#/Chapter15#C15" title="Link target outside of Sample">15. A Dark Corner Hero</span></p>
<p class="toc"><span href="#/Chapter16#C16" title="Link target outside of Sample">16. Dickey’s Plantation</span></p>
<p class="toc"><span href="#/Chapter17#C17" title="Link target outside of Sample">17. Shootout at Mountain Hill Church</span></p>
<p class="toc"><span href="#/Chapter18#C18" title="Link target outside of Sample">18. Funerals in the Dark Corner</span></p>
<p class="toc"><span href="#/Chapter19#C19" title="Link target outside of Sample">19. The Block House</span></p>
<p class="toc"><span href="#/Chapter20#C20" title="Link target outside of Sample">20. Dark Corner Medicine</span></p>
<p class="toc"><span href="#/Chapter21#C21" title="Link target outside of Sample">21. Dark Corner Fun</span></p>
<p class="toc1"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?3f2a2140